import { createSelector } from 'reselect'
import { slugify } from 'lib/slugify'
import { getPageData } from 'selectors/page'
import {
  getArtworkCategory,
  getArtworkMediums,
  getArtworkSubject,
  getArtworkStyles,
} from './artwork'
import { getArtist } from './artist'
import { getLinkCategory, buildPath } from '../helpers'
import { VISII } from '../helpers/constants'
// Carousels
export const getArtistArtworks = createSelector(
  [getPageData],
  (page): Array<Record<string, any>> => page.artistArtworks || []
)
export const getRelatedArtworks = createSelector(
  [getPageData],
  (page): Array<Record<string, any>> => page.relatedArtworks || []
)
export const getArtistSeeMore = createSelector(
  [getArtist],
  ({ firstName, lastName, userId }): Record<string, any> => ({
    link: `/account/artworks/${userId}`,
    title: `See More Art By ${firstName} ${lastName}`,
  })
)
// See More Art Link -> /category/style/subject/medium
export const getRelatedSeeMore = createSelector(
  [getArtworkCategory, getArtworkMediums, getArtworkSubject, getArtworkStyles],
  (category, mediums, subject, styles): Record<string, any> => ({
    link: buildPath([
      slugify(getLinkCategory(category) || ''),
      slugify(styles[0] || ''),
      slugify(subject || ''),
      slugify(mediums[0] || ''),
    ]),
    title: `See More ${styles[0] || ''} ${subject || ''} ${category || ''}`,
  })
)
export const getIsVisiiAvailable = createSelector(
  [getRelatedArtworks],
  (relatedArtworks): boolean =>
    relatedArtworks && relatedArtworks.length && relatedArtworks[0].api === VISII
)